import React, { useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";

const AttendanceSheet = ({ projects, onSubmit }) => {
  const [confirmedProjects, setConfirmedProjects] = useState({});

  if (!projects || projects.length === 0) {
    return (
      <div className="table-responsive">
        <p className="text-center text-muted">
          No attendance found for this month
        </p>
      </div>
    );
  }

  // Handle checkbox change
  const handleCheckboxChange = (projectId, checked) => {
    setConfirmedProjects((prev) => ({
      ...prev,
      [projectId]: checked,
    }));
  };

  // Handle submit for one project
  const handleProjectSubmit = (project) => {
    if (!confirmedProjects[project.PROJECT_ID]) {
      toast.error(
        `Please confirm attendance for ${project.PROJECT_NAME} before submitting.`
      );
      return;
    }

    // Send only this project
    onSubmit({
      projectId: project.PROJECT_ID,
      projectName: project.PROJECT_NAME,
    });
  };

  return (
    <div>
      {projects.map((project, pIdx) => (
        <div key={pIdx} className="mb-5 border p-3 rounded">
          <h4 className="text-center mb-3">
            {project.PROJECT_NAME} - Timesheet
          </h4>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>S/No</th>
                  <th>Name</th>
                  <th>Date</th>
                  <th>Date Attribute</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Actual Attendance</th>
                  <th>OT</th>
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>
                {project.attendance && project.attendance.length > 0 ? (
                  project.attendance.map((row, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{row.FULL_NAME}</td>
                      <td>{moment(row.DATE).format("DD-MMM-YY")}</td>
                      <td>{row.DATE_ATTRIBUTE}</td>
                      <td>{row.TIME_FROM || ""}</td>
                      <td>{row.TIME_TO || ""}</td>
                      <td>{row.ACTUAL_ATTENDANCE || ""}</td>
                      <td>{row.OT && row.OT !== "null" ? row.OT : ""}</td>
                      <td>
                        {row.REMARK && row.REMARK !== "null"
                          ? row.REMARK
                          : ""}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center text-muted">
                      No attendance found for this project
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* If attendance already confirmed */}
          {project.IS_CONFIRMED ? (
            <div className="alert alert-success mt-3 mb-0 text-center">
              ✅ Attendance verified and confirmed for this project.
            </div>
          ) : (
            <>
              {/* Confirmation checkbox */}
              <div className="form-check mt-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`confirm-${project.PROJECT_ID}`}
                  checked={!!confirmedProjects[project.PROJECT_ID]}
                  onChange={(e) =>
                    handleCheckboxChange(project.PROJECT_ID, e.target.checked)
                  }
                />
                <label
                  className="form-check-label"
                  htmlFor={`confirm-${project.PROJECT_ID}`}
                >
                  Confirm attendance for {project.PROJECT_NAME}
                </label>
              </div>

              {/* Submit button */}
              <div className="text-start mt-2">
                <button
                  className="btn btn-primary"
                  style={{
                    backgroundImage:
                      "linear-gradient(90deg, rgb(106, 151, 182), rgb(41, 87, 123))",
                    fontSize: 16,
                  }}
                  onClick={() => handleProjectSubmit(project)}
                >
                  Submit Confirmation
                </button>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default AttendanceSheet;
